import { useQuery } from "@tanstack/react-query";
import ProductService from "../api/product-service";
import { PRODUCT_API_URL } from "../api/urlMetaData";
import { useSelector } from "react-redux";

const useFeatureFlag = () => {
  const currentUser = useSelector((s) => s.auth.currentUser);

  let flags = {};

  const featureFlag = useQuery(
    ["featureFlag"],
    async ({ clientCode = currentUser.clientCode }) => {
      const res = await ProductService.get(
        `${PRODUCT_API_URL.FEATURE_FLAG}/${clientCode}`
      );
      return res.data;
    },
    {
      staleTime: 0,
      cacheTime: 0,
    }
  );

  if (featureFlag?.data?.body) {
    flags = { ...featureFlag?.data?.body };
  }

  return { flags };
};

export default useFeatureFlag;
